"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = require("styled-components");
var _oxygenConfig = require("@8x8/oxygen-config");
var _utils = _interopRequireDefault(require("../utils/utils"));
var _MilestoneTracker = require("../styled/MilestoneTracker");
var _excluded = ["milestones", "size", "showRoads", "theme"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * Renders the milestone tracker
 *
 * @param {Array} milestones - array of data for each milestone
 * @param {Number} size - size of the milestone bullet
 * @param {Boolean} showRoads - display roads between milestone bullets
 * @param {Object} theme - Milestone tracker theme
 * @param {Object} rest - rest of the props
 *
 * @return {JSX}
 */
var MilestoneTracker = function MilestoneTracker(_ref) {
  var milestones = _ref.milestones,
    size = _ref.size,
    showRoads = _ref.showRoads,
    theme = _ref.theme,
    rest = _objectWithoutProperties(_ref, _excluded);
  /**
   * Renders each milestone
   *
   * @return {Array} - array of JSX content for each milestone
   */
  var renderMilestones = function renderMilestones() {
    return milestones.map(function (milestone, index) {
      var _milestone$testId = milestone.testId,
        testId = _milestone$testId === void 0 ? 'MILESTONE' : _milestone$testId,
        id = milestone.id,
        description = milestone.description,
        isCompleted = milestone.isCompleted,
        title = milestone.title,
        onClick = milestone.onClick;
      var hasInnerDescription = _utils["default"].hasInnerDescription(milestone);
      var isFirst = index === 0;
      var isLast = index + 1 === milestones.length;
      return /*#__PURE__*/_react["default"].createElement(_MilestoneTracker.StyledMilestoneContainer, _extends({}, rest, (0, _oxygenConfig.getTestAttributes)(testId), {
        key: id
      }), !isFirst && /*#__PURE__*/_react["default"].createElement(_MilestoneTracker.StyledRow, null, /*#__PURE__*/_react["default"].createElement(_MilestoneTracker.StyledGraphicContainer, {
        size: size
      }, /*#__PURE__*/_react["default"].createElement(_MilestoneTracker.StyledRoad, _extends({}, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_UPPER_ROAD")), {
        isCompleted: isCompleted,
        showRoads: showRoads
      })))), /*#__PURE__*/_react["default"].createElement(_MilestoneTracker.StyledRow, {
        onClick: onClick
      }, /*#__PURE__*/_react["default"].createElement(_MilestoneTracker.StyledBulletContainer, {
        hasInnerDescription: hasInnerDescription,
        size: size
      }, !isFirst && /*#__PURE__*/_react["default"].createElement(_MilestoneTracker.StyledRoad, _extends({}, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_UPPER_BULLET_ROAD")), {
        isCompleted: isCompleted,
        showRoads: showRoads
      })), /*#__PURE__*/_react["default"].createElement(_MilestoneTracker.StyledBullet, _extends({}, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_BULLET")), {
        isCompleted: isCompleted,
        size: size
      }), _utils["default"].getMilestoneContent(milestone)), !isLast && /*#__PURE__*/_react["default"].createElement(_MilestoneTracker.StyledRoad, _extends({}, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_BULLET_ROAD")), {
        isCompleted: isCompleted,
        showRoads: showRoads
      }))), /*#__PURE__*/_react["default"].createElement(_MilestoneTracker.StyledTitle, _extends({}, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_TITLE")), {
        isCompleted: isCompleted
      }), title)), /*#__PURE__*/_react["default"].createElement(_MilestoneTracker.StyledRow, null, /*#__PURE__*/_react["default"].createElement(_MilestoneTracker.StyledGraphicContainer, {
        size: size
      }, !isLast && /*#__PURE__*/_react["default"].createElement(_MilestoneTracker.StyledRoad, _extends({}, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_ROAD")), {
        isCompleted: isCompleted,
        showRoads: showRoads
      }))), /*#__PURE__*/_react["default"].createElement(_MilestoneTracker.StyledDescription, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_DESCRIPTION")), !hasInnerDescription && description)));
    });
  };
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(_MilestoneTracker.StyledMilestoneTrackerContainer, null, renderMilestones()));
};
MilestoneTracker.propTypes = {
  milestones: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    testId: _propTypes["default"].string,
    onClick: _propTypes["default"].func,
    id: _propTypes["default"].string.isRequired,
    title: _propTypes["default"].string,
    description: _propTypes["default"].node,
    isCompleted: _propTypes["default"].bool,
    icon: _propTypes["default"].node
  })),
  size: _propTypes["default"].number,
  theme: _propTypes["default"].object.isRequired,
  showRoads: _propTypes["default"].bool
};
MilestoneTracker.defaultProps = {
  milestones: [],
  size: 48,
  showRoads: true
};
var _default = (0, _oxygenConfig.withTheme)(MilestoneTracker, 'milestoneTracker');
exports["default"] = _default;